import { DashboardIcon } from 'images/icons/png/v2';
import { EpdLinks } from 'routes/EpdRoutes';
import styled from 'styled-components';
import { HyperLink } from 'styles/Styles.styled';

const EmptyRequestsList = () => {
  return (
    <EmptyBox>
      <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'center' }}>
        <IconBox>
          <img src={DashboardIcon} alt="dashboard icon" />
        </IconBox>
        <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'center' }}>
          <NoRequestsText>No requests found</NoRequestsText>
          <InformativeText>
            {<HyperLink href={EpdLinks.organisation('connect')}>Request to join an organisation</HyperLink>}
            &nbsp;to get started
          </InformativeText>
        </div>
      </div>
    </EmptyBox>
  );
};

const EmptyBox = styled.div`
  width: 100%;
  height: 400px;
  margin: auto;
  border-radius: 4px;
  padding-left: 3rem;
  padding-right: 3rem;
  padding-top: 0rem;
  padding-bottom: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  > div {
    flex: 1;
  }
`;

const IconBox = styled.div`
  width: 158px;
  height: 158px;
  margin: auto;
  align-self: flex-start;
`;

const NoRequestsText = styled.h2`
  ${(props) => props.theme.typography.bodyInput}
  color: ${(props) => props.theme.colors.primaryBlack};
  font-size: 18px;
  font-weight: 600;
`;

const InformativeText = styled.span`
  ${(props) => props.theme.typography.bodyInput}
  font-weight: 500;
  color: ${(props) => props.theme.colors.primaryBlack50};
`;

export default EmptyRequestsList;
